import React from 'react';
import styled from 'styled-components';
import Hotspot from './Hotspot';

const HomeContainer = styled.div`
  width: 100vw;
  height: 100vh;
  position: relative;
  background: #000;
  overflow: hidden;
`;

const SceneImage = styled.div`
  width: 100%;
  height: 100%;
  background-image: url('/enhanced_3D-SCENE-3.png');
  background-size: cover;
  background-position: center center;
  background-repeat: no-repeat;
  position: relative;
  
  /* Mobile responsiveness */
  @media (max-width: 768px) {
    /* Make the background wider to allow panning */
    width: 150%;
    background-size: cover;
    background-position: center center;
    
    /* Enable horizontal scrolling */
    overflow-x: scroll;
    overflow-y: hidden;
    -webkit-overflow-scrolling: touch;
    
    /* Hide scrollbars but keep functionality */
    scrollbar-width: none;
    -ms-overflow-style: none;
    &::-webkit-scrollbar {
      display: none;
    }
    
    /* Allow touch panning */
    touch-action: pan-x;
    
    /* Center the initial view around the dot position */
    /* Since dot is at 30% on mobile, we need to offset to center it */
    margin-left: -20%; /* Adjusted to center around the 30% dot position */
  }
  
  @media (max-width: 480px) {
    width: 180%;
    /* For smaller screens, adjust centering for 30% dot position */
    margin-left: -30%; /* Adjusted to center around the 30% dot position */
    background-position: center center;
    min-height: 100vh;
    background-attachment: scroll;
  }
`;

const ScrollContainer = styled.div`
  width: 100%;
  height: 100%;
  overflow-x: auto;
  overflow-y: hidden;
  -webkit-overflow-scrolling: touch;
  
  /* Hide scrollbars */
  scrollbar-width: none;
  -ms-overflow-style: none;
  &::-webkit-scrollbar {
    display: none;
  }
  
  @media (min-width: 769px) {
    overflow: hidden;
  }
`;

function HomePage() {
  return (
    <HomeContainer>
      <ScrollContainer>
        <SceneImage>
          <Hotspot 
            position={{ 
              x: '36%', 
              y: '58%',
              mobileX: '30%',
              mobileY: '58%'
            }} 
            onClick={() => window.open('https://aledellagiusta.myshopify.com/products/triade-stefano?variant=51282886066522', '_blank')}
          />
        </SceneImage>
      </ScrollContainer>
    </HomeContainer>
  );
}

export default HomePage; 